import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import sendNotification from '../../../../../../notifications/sendNotification';
import useIsWindowVisible from '../../../../Hooks/useIsWindowVisible';
import { SessionComplianceChecklistItem } from './type';

export default function useTriggerReminder() {
  const { t } = useTranslation('notifications');
  const { enqueueSnackbar } = useSnackbar();
  const { isVisible } = useIsWindowVisible();

  return (topic: SessionComplianceChecklistItem) => {
    if (!isVisible) {
      sendNotification(
        t('reminder-compliance-task.title', { title: topic.topic.text }),
        {
          body: t('reminder-compliance-task.body', { title: topic.topic.text }),
          actions: [{ action: 'open', title: t('reminder-compliance-task.open') }],
        },
      );
    }
    enqueueSnackbar(t('reminder-compliance-task.title', { title: topic.topic.text }), {
      variant: 'warning',
    });
  };
}
